<template>
  <div class="top-dom">
    <el-row type="flex" justify="space-between" class="line-row">
      <el-col :xs="12" :sm="6" class="one-title left-title">
        <img :src="require('$img/web-icon2.png')" alt="" width="197px" height="37px">
      </el-col>
      <el-col :xs="12" :sm="2" class="one-title right-title" >
        <!-- <div @click="toInfo" v-if="from !== 'login'">最有效的地产垂直招聘平台</div> -->
        <el-popover
          placement="bottom-end"
          width="240"
          trigger="click">
          <div class="loginrCodeText">微信扫码，免费找地产工作</div>
          <img :src="require('$img/login_code.png')" alt="" width="85%" style="margin-left: 19px;">
          <div class="loginr" slot="reference">
            <img class="loginrCode" :src="require('$img/loginr-code.png')" alt="" width="16px" height="16px">  
            <span class="loginrText">求职者入口</span>           
          </div>
        </el-popover>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'TopHeader',
  props: ['from'],
  methods: {
    toInfo(){
      this.$router.push('/info/index')
    }
  }
}
</script>

<style lang='scss' >
@import '$styles/global.scss';

@media screen and (max-width: 768px) {
  .right-title{
    font-size: 15px;
    text-align: right;
  }

  .line-row{
    padding: 0 10px;
  }
}

@media only screen and (min-width: 768px) {
  .right-title{
    font-size: 20px;
    text-align: right;
  }

  .line-row{
    padding: 0 30px;
  }
}

.top-dom{
  width: 100%;
  height: 58px;
  border-bottom: 1px solid $second-color;

  .line-row{
    height: 100%;
  }

  .one-title{
    line-height: 52px;
  }

  .left-title{
    font-size: 20px;
    @include flex-box(flex-start);
    box-sizing: border-box;
    padding-left: 2%;

  }
  .loginrCodeText{
    margin:19px 0 15px;
    text-align:center;
    color:#5E5E5E;
    font-size:13px
  }
  .loginr{
    cursor:pointer;
    .loginrCode{
      position: relative;
      top: 2.5px;
      right: 5px;
    }
    .loginrText{
      font-size:16px;
      color:#4061F8
    }
  }
  
}
</style>
